import React from "react";
import {
  CopyOutlined,
  FileOutlined,
  PlusOutlined,
  DownloadOutlined,
  DollarOutlined,
  AreaChartOutlined,
  UnorderedListOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import { PageHeader, Button, message, Tag } from "antd";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { object } from "prop-types";
import { getBreadcrumbProps } from "../../../AppRouter";
import { downloadContractPosts } from "../../../redux/contracts/contractActions";
import ContractByIdStats from "./ContractByIdStats";
import checkAuth from "../../../utils/checkAuth";
import EditContractButton from "./EditContractButton";
import { getTagColor } from "../../../utils/getTagColor";
import { displayDate } from "../../../utils/dates";
import { copyFormattedLinkToClipboard } from "../../../utils/copyToClipboard";

function ContractByIdHeader({ contract }) {
  const history = useHistory();

  console.log("contract", JSON.stringify(contract, null, 2));

  const dispatch = useDispatch();

  const roles = useSelector(state => state.auth.roles);
  const isAdmin = checkAuth.has(roles, ["admin"]);

  const shouldDisplayBillingDashboardButton = contract.billingContractId;

  const buttons = [
    ...(shouldDisplayBillingDashboardButton
      ? [
          <Button
            icon={<DollarOutlined />}
            key="billing"
            type="default"
            onClick={async () => {
              await navigator.clipboard.writeText(
                `${process.env.REACT_APP_INFLUENCER_BRAND_HOST}brand/billing/${contract.billingContractId}`
              );
              message.success("Billing link copied to clipboard");
            }}
          >
            Billing
          </Button>,
        ]
      : []),
    <Button
      icon={<AreaChartOutlined />}
      key="dashboard"
      type="default"
      onClick={async () => {
        await navigator.clipboard.writeText(
          `${process.env.REACT_APP_INFLUENCER_BRAND_HOST}brand/dashboard/${contract.contractId}`
        );
        message.success("Dashboard link copied to clipboard");
      }}
    >
      Dashboard
    </Button>,
    <Button
      icon={<UnorderedListOutlined />}
      key="gallery"
      type="default"
      onClick={async () => {
        await navigator.clipboard.writeText(
          `${process.env.REACT_APP_INFLUENCER_BRAND_HOST}brand/contracts/${contract.contractId}`
        );
        message.success("Gallery link copied to clipboard");
      }}
    >
      Gallery
    </Button>,
    <Button
      icon={<CopyOutlined />}
      key="landing"
      type="default"
      onClick={async () => {
        await navigator.clipboard.writeText(
          `${process.env.REACT_APP_INFLUENCER_BRAND_HOST}campaigns/${contract.contractId}`
        );
        message.success("Landing page link copied to clipboard");
      }}
    >
      Landing
    </Button>,
    <Button
      icon={<DownloadOutlined />}
      key="csv"
      onClick={
        () => dispatch(downloadContractPosts(contract)) //download all posts belonging to contract
      }
    >
      CSV
    </Button>,
  ];

  if (isAdmin) {
    buttons.push(
      <EditContractButton key="3" text="Edit" contract={contract} />,
      <Button
        key="4"
        type="primary"
        onClick={() =>
          history.push(
            `/campaigns/add/${contract.companyId}/${contract.contractId}`
          )
        }
      >
        <PlusOutlined />
        New Campaign
      </Button>
    );
  }

  return (
    <div className="main-no-padding">
      <PageHeader
        ghost={false}
        breadcrumb={getBreadcrumbProps(history.location)} //see https://ant.design/components/breadcrumb/#Use-with-browserHistory
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingBottom: "0",
            }}
          >
            <span
              onClick={async () =>
                await copyFormattedLinkToClipboard({
                  text: contract.name,
                  url: window.location.href,
                })
              }
            >
              {contract.name}
            </span>
            <Tag
              color={getTagColor(contract.state)}
              style={{ marginLeft: "10px" }}
            >
              {contract.state}
            </Tag>
          </div>
        }
        subTitle={`${displayDate(contract.startDate).format("MMM Do YYYY")}${
          //conditional if end date
          contract.endDate
            ? ` - ${displayDate(contract.endDate).format("MMM Do YYYY")}`
            : ""
        }`}
        extra={buttons}
      >
        <ContractByIdStats contract={contract} />
      </PageHeader>
    </div>
  );
}

ContractByIdHeader.propTypes = {
  contract: object,
};

export default ContractByIdHeader;
